"use client"
import React, { useState } from "react";
import GoToLink from "@/components/shared/GoToLink";
import EventCalendarLink from "@/components/shared/EventCalendarLink";

const EventCTA = ({ event }) => {
  if (event) {
    return (
      <>
        {event.socialProfile &&
        event.socialProfile.length > 0 &&
        event.socialProfile.findIndex(sp => sp.type === "TICKETS") > -1 ? (
          <GoToLink
            classProps="with-icon"
            ownerId={event.owner.id}
            contentId={event.id}
            type="EVENT"
            url={event.socialProfile.find(sp => sp.type === "TICKETS").value}
            toRender={
              <>
                <i className="fa-solid fa-ticket"></i>
                <span>Get Tickets</span>
              </>
            }
          />
        ) : (
          <EventCalendarLink event={event} />
        )}
      </>
    );
  } else return <></>;
};
export default EventCTA;
